import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RouterProvider } from 'react-router';

import { AppProvider } from './main-provider';
import { createRouter } from './routes';

const AppRouter = () => {
  const queryClient = useQueryClient();

  const router = useMemo(() => createRouter(queryClient), [queryClient]);

  return <RouterProvider router={router} />;
};

function App() {
  // 本番環境の場合、コンソール出力を無効にする
  if (import.meta.env.VITE_APP_ENV === 'prod') {
    console.log =
      console.info =
      console.debug =
      console.warn =
      console.error =
        () => {};
  }
  // テスト環境以外の場合、console.infoを無効にする
  if (import.meta.env.VITE_APP_ENV !== 'test') {
    console.info = () => {};
  }
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
}

export default App;
